import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

export const authModalStyles = makeStyles((theme: Theme) =>
    createStyles({
        header: {
            marginTop: "10px",
            marginBottom: "20px",
        },
        icon: {
            cursor: "pointer",
            alignSelf: "end",
            position: "absolute",
        },
        paper: {
            backgroundColor: "#FFFFFF",
            boxShadow: theme.shadows[5],
            paddingTop: "10px",
            paddingLeft: "15px",
            paddingRight: "15px",
            paddingBottom: "10px",
        },
        firstGrid: {
            marginTop: "10px",
            marginBottom: "10px",
        },
        button: {
            padding: "8px 16px 8px 16px",
            fontWeight: 200,
        },
        confirm: {
            border: "1px solid #270ADC",
            background: "#270ADC",
            color: "white",
            "&:hover": {
                backgroundColor: "#1B079C",
                border: "1px solid #1B079C",
            },
        },
        cancel: {
            border: "1px solid #333333",
            marginRight: "5px",
            "&:hover": {
                backgroundColor: "inherit",
            },
        },
        formControl: {
            width: "100%",
            marginBottom: "20px",
        },
        form: {
            width: "100%",
        },
        link: {
            display: "block",
        },
        gridModalButtons: {
            marginTop: "30px",
        },
        errorMessage: {
            marginTop: "2px",
            marginBottom: "2px",
            color: "rgba(223, 80, 49, 1)",
        },
        formErrorYes: {
            visibility: "visible",
            color: "rgba(223, 80, 49, 1)",
        },
        formErrorNo: {
            color: "rgba(223, 80, 49, 1)",
            visibility: "hidden",
        },
        modal: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
        },
        mainGridAuth: {
            "flex-grow": 0,
            "max-width": "27%",
            "flex-basis": "27%",
        },
    })
);
